import { useState } from "react";

import { Button } from "~/common/components";
import { OrganizationProvidersResponse } from "~/providers/types/teamMembers";
import { UpsertConsultationLinkModal } from "./UpsertConsultationLinkModal";

interface CreateConsultationLinkModalProps {
  providers: OrganizationProvidersResponse[];
}

export const CreateConsultationLinkModal = ({
  providers,
}: CreateConsultationLinkModalProps) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <Button
        onClick={() => {
          setShow(true);
        }}
        className="w-full whitespace-nowrap sm:w-fit"
      >
        Create new link
      </Button>
      <UpsertConsultationLinkModal
        show={show}
        onClose={() => setShow(false)}
        providers={providers}
      />
    </div>
  );
};
